import { render, staticRenderFns } from "./infoRegForm.vue?vue&type=template&id=14aa309a&scoped=true"
import script from "./infoRegForm.vue?vue&type=script&lang=js"
export * from "./infoRegForm.vue?vue&type=script&lang=js"
import style0 from "./infoRegForm.vue?vue&type=style&index=0&id=14aa309a&lang=scss&scoped=true"
import style1 from "./infoRegForm.vue?vue&type=style&index=1&id=14aa309a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aa309a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14aa309a')) {
      api.createRecord('14aa309a', component.options)
    } else {
      api.reload('14aa309a', component.options)
    }
    module.hot.accept("./infoRegForm.vue?vue&type=template&id=14aa309a&scoped=true", function () {
      api.rerender('14aa309a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/infoRegForm.vue"
export default component.exports